module.exports = __webpack_public_path__ + "img/Arcane_Splash.a71c7438.jpg";